import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../shared/services/admin/admin.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {

  username: string
  password: string

  constructor(private admin: AdminService, private router: Router) { }

  ngOnInit() {
  }

  login() {
    this.admin
      .login(this.username, this.password)
      .subscribe(res => {
        this.router.navigate(['admin'])
      })
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/admin/containers/admin-login/admin-login.component.ts